import * as R from 'ramda';
import {handleActions} from 'redux-actions';
import {createStore, applyMiddleware} from 'redux';
import promiseMiddleware from 'redux-promise';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import campaigns from './ducks/campaigns';

const createStoreWithMiddleware = applyMiddleware(
    promiseMiddleware,
    thunkMiddleware,
    createLogger()
)(createStore);

const rootReducer = handleActions(R.mergeAll([campaigns]));

export const store = createStoreWithMiddleware(rootReducer, {
    campaigns: {},
    hasRejectionPermission:
        !!window.sn &&
        !!window.sn.feature_permissions &&
        window.sn.feature_permissions.includes('brand_may_reject_from_distributing')
});



// WEBPACK FOOTER //
// ./brand/content_approval/store.js